export default {"src":"__ASTRO_ASSET_IMAGE__HEiBZPsY__","width":512,"height":512,"format":"svg"}